exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_articles_1h8k5dD8vUFzuLP5E6AiM0 {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_qwbuGgDTfNIRdQBcr2CyU {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_1Te1ePTvFevo6YV_IdmYNT {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_1XeDKodFRqQanPpr97xViJ {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_articles": "IA_articles_1h8k5dD8vUFzuLP5E6AiM0",
	"IA_filters": "IA_filters_qwbuGgDTfNIRdQBcr2CyU",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_1Te1ePTvFevo6YV_IdmYNT",
	"IA_paginationPageCount": "IA_paginationPageCount_1XeDKodFRqQanPpr97xViJ"
};